import React from 'react';
import {
  Box,
  VStack,
  Heading,
  Text,
  Container,
  useColorModeValue,
  Divider,
  useBreakpointValue
} from '@chakra-ui/react';

const About = () => {
  const accentColor = useColorModeValue('yellow.400', 'yellow.500');
  const headingSize = useBreakpointValue({ base: '2xl', md: '3xl' });
  const subHeadingSize = useBreakpointValue({ base: 'lg', md: 'xl' });

  return (
    <Box minH="100vh" position="relative" overflow="hidden">
      {/* Decorative Elements - Desktop only */}
      
      <Box
        display={{ base: 'block', md: 'none' }}
        position="absolute"
        top="60%"
        right="10%"
        w="150px"
        h="150px"
        bg="yellow.300"
        borderRadius="40% 60% 30% 70%"
        opacity="0.5"
        zIndex="0"
      />
      <Box
        display={{ base: 'none', md: 'block' }}
        position="absolute"
        bottom="10%"
        left="15%"
        w="100px"
        h="100px"
        bg="yellow.200"
        borderRadius="60% 40% 80% 20%"
        opacity="0.7"
        zIndex="0"
      />

      {/* Decorative Line - Desktop only */}
      <Box
        display={{ base: 'none', md: 'block' }}
        position="absolute"
        top="20%"
        right="0"
        w="200px"
        h="4px"
        bg="yellow.400"
        borderRadius="full"
        transform="rotate(45deg)"
        opacity="0.8"
        zIndex="0"
      />

      {/* Mobile-only decorative elements */}
      <Box
        display={{ base: 'block', md: 'none' }}
        position="absolute"
        top="10%"
        right="15%"
        w="40px"
        h="40px"
        bg="yellow.300"
        borderRadius="50%"
        opacity="0.4"
        zIndex="0"
      />
      <Box
        display={{ base: 'block', md: 'none' }}
        position="absolute"
        bottom="15%"
        left="10%"
        w="30px"
        h="30px"
        bg="yellow.400"
        borderRadius="40% 60% 30% 70%"
        opacity="0.3"
        zIndex="0"
      />
      {/* new additions for mobile only */}
      <Box
        display={{ base: 'block', md: 'none' }}
        position="absolute"
        top="5%"
        left="10%"
        w="25px"
        h="25px"
        bg="yellow.200"
        borderRadius="30% 70% 70% 30% / 30% 30% 70% 70%"
        opacity="0.5"
        zIndex="0"
      />

      <Box
        display={{ base: 'block', md: 'none' }}
        position="absolute"
        top="15%"
        left="5%"
        w="55px"
        h="55px"
        bg="yellow.400"
        borderRadius="50%"
        opacity="0.6"
        zIndex="0"
      />

      <Container
        maxW="7xl"
        position="relative"
        zIndex="1"
        minH="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        py={{ base: 10, md: 0 }}
      >
        <VStack spacing={{ base: 8, md: 16 }} align="center" px={{ base: 4, md: 0 }}>
          {/* Hero Section */}
          <VStack spacing={{ base: 4, md: 6 }} textAlign="center" maxW="4xl" alignItems="center">
            <Heading
              as="h1"
              size={headingSize}
              color="gray.800"
              fontWeight="bold"
              lineHeight="1.2"
            >
              Welcome to PiePOS!
            </Heading>

            <Box position="relative">
              <Box position="relative" display="inline-block">
                <Heading
                  as="h2"
                  size={subHeadingSize}
                  color="gray.700"
                  fontWeight="semibold"
                  lineHeight="1.4"
                  maxW="3xl"
                  textAlign="center"
                >
                  <Box as="span" position="relative" display="inline-block">
                    India&apos;s first
                    {/* Doodle circle */}
                    <Box
                      position="absolute"
                      top="-4px"
                      left="-10px"
                      w="110%"
                      h="140%"
                      border="4px solid"
                      borderColor={accentColor}
                      borderRadius="50%"
                      transform="rotate(-5deg)"
                      opacity={0.9}
                      zIndex={-1}
                    />
                  </Box>{" "}
                  <Box as="span" position="relative" display="inline-block">
                    AI Native
                    {/* Doodle underline */}
                    <Box
                      position="absolute"
                      bottom={-2}
                      left="0"
                      w="100%"
                      h="2px"
                      bg={accentColor}
                      borderRadius="full"
                      transform="rotate(-2deg)"
                      opacity={0.9}
                    />
                  </Box>{" "}
                  Restaurant Management System and POS.
                </Heading>
              </Box>
            </Box>

            <Text
              fontSize={{ base: 'md', md: 'xl' }}
              color="gray.600"
              maxW="3xl"
              lineHeight="1.6"
              fontWeight="medium"
            >
              From menu creation to order management, we've got everything you need
              to run your restaurant successfully in the AI era.
            </Text>

            <Divider borderColor={accentColor} w="150px" borderWidth={2} />
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
};

export default About;